export default {
  "gemExchangeTagsAdmin.thead.index": "#NO",
  "gemExchangeTagsAdmin.thead.sort": "Sort",
  "gemExchangeTagsAdmin.thead.tagName": "TagName",
  "gemExchangeTagsAdmin.thead.tagId": "TagId",
  "gemExchangeTagsAdmin.thead.createdAt": "CreatedAt",
  "gemExchangeTagsAdmin.thead.updatedAt": "UpdatedAt",

  "gemExchangeTagsAdmin.add": "Add",
  "gemExchangeTagsAdmin.edit": "Edit",
  "gemExchangeTagsAdmin.details": "Details",
  "gemExchangeTagsAdmin.delete": "Delete",

  "gemExchangeTagsAdmin.thead.action": "Action",
};
